﻿'use strict';
var Backbone = require('backbone');
var Period = require('../models/period');

module.exports = Backbone.Collection.extend({
    model: Period
});